var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { ProgressBar } from "../../ProgressBar";
import { Overlay, OVERLAY_CONTENT_MOD, OVERLAY_VIEW } from "../../Overlay";
var ProgressWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    ", "\n"], ["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    ", "\n"])), function (_a) {
    var block = _a.block;
    return (block ? "top: 0;" : "height: 2px;");
});
export var PageWizardProgress = function (_a) {
    var className = _a.className, block = _a.block, rest = __rest(_a, ["className", "block"]);
    return (React.createElement(ProgressWrapper, { className: className, block: block },
        React.createElement(Overlay, { "data-selector-id": rest['data-selector-id'] || 'pagewizard-wizardprogress', view: OVERLAY_VIEW.soft, contentMod: OVERLAY_CONTENT_MOD.bottom },
            React.createElement(ProgressBar, null))));
};
PageWizardProgress.displayName = 'WizardProgress';
var templateObject_1;
//# sourceMappingURL=PageWizardProgress.js.map